import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { QueryVal } from 'Helpers/Query';
import { useCustomLayoutContext } from 'Components/UI/CustomLayout/CustomLayoutContext';
import TabPopoutModal from './TabPopoutModal';

const styles = () => ({
  root: {
    position: 'absolute',
    width: '100%',
    overflowY: 'auto',
    zIndex: 0,
    height: '100%',
  },
  hidden: {
    display: 'none !important', // It's imperative that this never loses.
  },
});

const ColumnContent = ({
  activeTabName,
  className,
  classes,
  maxHeight,
  columnConfiguration,
  tabRegistry,
  openTabs,
  openTab,
  setActiveTab,
}) => {
  const poppedOutTab = QueryVal('poppedOutTab');
  const { hasTabBeenVisited } = useCustomLayoutContext();

  const isTabPoppedOut = poppedOutTab === activeTabName;

  if (isTabPoppedOut) {
    const { component: Component } = tabRegistry[activeTabName];
    return (
      <TabPopoutModal
        Component={Component}
      />
    );
  }

  return (
    <div
      className={classNames(classes.root, className)}
      style={{
        maxHeight,
      }}
    >
      {columnConfiguration.attr('tabs')
        .resources()
        .list()
        .filter(tabResource => tabRegistry[tabResource.attr('name')])
        .filter(tabResource => hasTabBeenVisited(tabResource.attr('name')))
        .map((tabResource) => {
          const tabName = tabResource.attr('name');
          const Component = tabRegistry[tabName].component;

          return (
            <Component
              classes={{
                container: classNames({ [classes.hidden]: activeTabName !== tabName }),
                root: classNames({ [classes.hidden]: activeTabName !== tabName }),
              }}
              key={tabName}
              openTabs={openTabs}
              openTab={openTab}
              setActiveTab={setActiveTab}
            />
          );
        })}
    </div>
  );
};

ColumnContent.defaultProps = {
  className: '',
};

ColumnContent.propTypes = {
  activeTabName: PropTypes.string.isRequired,
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  columnConfiguration: PropTypes.object.isRequired,
  maxHeight: PropTypes.number.isRequired,
  tabRegistry: PropTypes.object.isRequired,
  openTabs: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.array,
  ]).isRequired,
  openTab: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.func,
  ]).isRequired,
  setActiveTab: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.func]).isRequired,
};

export default withStyles(styles)(ColumnContent);
